import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import 'react-slidedown/lib/slidedown.css';
import bn from '../../utils/bemnames';
import Modal from './Modal';
import pathConstant, { QUERY_NEWS } from '../../constants/PathsConstant';

const bem = bn.create('linkShare');

const LinkShare = ({ newsid, mailSubject, mailBody }) => {
  const [isShowShareIcons, setIsShowShareIcons] = useState(false);
  const [isShowModel, setIsShowModel] = useState(false);
  function toggleShareIcons() {
    setIsShowShareIcons((wasOpened) => !wasOpened);
  }

  function useKeypress(key, action) {
    useEffect(() => {
      async function onKeyup(e) {
        if (e.key === key) await action(false);
      }
      window.addEventListener('keyup', onKeyup);
      return () => window.removeEventListener('keyup', onKeyup);
    }, [action, key]);
  }

  useKeypress('Enter', setIsShowModel);

  const sendMail = () => {
    const mBody = encodeURIComponent(
      `${mailBody.replace(/(<([^>]+)>)/gi, '')}\n\n
      ${window.location.host}${pathConstant.NEWS_OVERVIEW}${QUERY_NEWS}${newsid}`);

    const msubject = encodeURIComponent(mailSubject.replace(/(<([^>]+)>)/gi, ''));
    const link = `mailto:?subject=Insightia News: ${msubject}&body=${mBody}`;
    window.location.href = link;
    return false;
  };

  const handleLinkClick = () => {
    navigator.clipboard.writeText(`${window.location.host + pathConstant.NEWS_OVERVIEW}${QUERY_NEWS}${newsid}`);
    handleToggleModel(true);
  };

  const handleToggleModel = (val) => {
    setIsShowModel(val);
  };

  return (
    <div className='row col-12 justify-content-end'>
      <Modal
        show={isShowModel}
        handleClose={() => handleToggleModel(false)}
        size='md'
        isShowFooter
        title='News URL copied to clipboard'
      >
        {`link to: ${window.location.host}${pathConstant.NEWS_OVERVIEW}${QUERY_NEWS}${newsid}`}
      </Modal>
      <button
        aria-label=' '
        type='button'
        className={
          isShowShareIcons
            ? 'btn newsShare draw meet btnActive order-2'
            : 'btn newsShare draw meet order-2'
        }
        onClick={(e) => {
          e.stopPropagation();
          toggleShareIcons();
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path fillRule="evenodd" clipRule="evenodd" d="M22.75 5.5C22.75 3.15279 20.8472 1.25 18.5 1.25C16.1528 1.25 14.25 3.15279 14.25 5.5C14.25 6.00092 14.3367 6.4816 14.4958 6.92787L9.57962 9.87759C8.70887 8.88017 7.42803 8.25 6 8.25C3.37665 8.25 1.25 10.3766 1.25 13C1.25 15.6234 3.37665 17.75 6 17.75C7.73722 17.75 9.25662 16.8174 10.0849 15.4256L11.7802 16.4428C11.4424 17.0523 11.25 17.7537 11.25 18.5C11.25 20.8472 13.1528 22.75 15.5 22.75C17.8472 22.75 19.75 20.8472 19.75 18.5C19.75 16.1528 17.8472 14.25 15.5 14.25C14.4461 14.25 13.4818 14.6336 12.7391 15.2688L10.6422 14.0107C10.7128 13.685 10.75 13.3468 10.75 13C10.75 12.3434 10.6168 11.7179 10.3759 11.1491L15.2421 8.22938C16.0217 9.15897 17.1918 9.75 18.5 9.75C20.8472 9.75 22.75 7.84721 22.75 5.5ZM15.75 5.5C15.75 3.98122 16.9812 2.75 18.5 2.75C20.0188 2.75 21.25 3.98122 21.25 5.5C21.25 7.01878 20.0188 8.25 18.5 8.25C16.9812 8.25 15.75 7.01878 15.75 5.5ZM6 9.75C4.20507 9.75 2.75 11.2051 2.75 13C2.75 14.7949 4.20507 16.25 6 16.25C7.79493 16.25 9.25 14.7949 9.25 13C9.25 11.2051 7.79493 9.75 6 9.75ZM15.5 15.75C13.9812 15.75 12.75 16.9812 12.75 18.5C12.75 20.0188 13.9812 21.25 15.5 21.25C17.0188 21.25 18.25 20.0188 18.25 18.5C18.25 16.9812 17.0188 15.75 15.5 15.75Z" fill="#1E1E1E" />
        </svg>
      </button>
      {isShowShareIcons && (
        <div className={bem.b('fadeInAnimation order-1')}>
          <div>
            <div className=''>
              <ul className='shareicons'>
                {/* <li className="">
                  <svg width={25} height={25} fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 17 17">
                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                  </svg>
                </li>
                <li className="">
                  <i className="bi bi-linkedin" />
                </li>
                <li className="">
                  <i className="bi bi-twitter" />
                </li> */}
                <li className=''>
                  <i className='bi bi-files' onClick={handleLinkClick} />
                </li>
                <li className=''>
                  <i className='bi bi-envelope-fill' onClick={sendMail} />
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

LinkShare.propTypes = {
  mailBody: PropTypes.string,
  mailSubject: PropTypes.string,
  newsid: PropTypes.number
};

LinkShare.defaultProps = {
  mailBody: '',
  mailSubject: '',
  newsid: 0
};

export default React.memo(LinkShare);
